import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import API from '../Services/Advance'


const AdvanceList = () => {
    const [error, setError] = useState({});
    const [advance, setAdvance] = useState("");
    const [id, setId] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 10
    const [advanceList, setAdvanceList] = useState([])
    const [status, setStatus] = useState([])
    const [createdDate, setCreatedDate] = useState([])


    useEffect(() => {
        getAdvanceList()
    }, [currentPage])

    const handleFieldChange = (e) => {
        const value = e.target.value;
        setAdvance(value);

        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors.advance;
                return updatedErrors;
            });
        }
    };

    const getAdvanceList = async () => {
        try {
            const response = await API.getAdvancdData('');
            //console.log('response data....', response?.data?.data);
            setAdvanceList(response?.data?.data)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection.");
            } else if (error.response.status === 403) {
                window.location.replace("/Login");
                toast.error("Session expired. Please log in again.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };
    const handleGetData = async (id) => {
        // console.log("id......", id)
        try {
            // const response = await API.getAdvancdData({ id: id });
            const response = await API.getAdvancdData(`?id=${id}`);
           // console.log('rrr', response);
            const fetchedData = response?.data?.data?.[0];
            //  console.log('fetchedData', fetchedData);
            if (fetchedData) {
                //setHighlight(true);
                setId(fetchedData.id);
                setAdvance(fetchedData?.advance)
                setStatus(fetchedData?.is_active)
                setCreatedDate(fetchedData?.createdAt)
            } else {
                toast.error("Failed to Advance details.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const validateFields = () => {
        const errors = {};
        const trimmedValue = advance.trim();

        if (!trimmedValue) {
            errors.advance = "Advance is required";
        } else if (!/^\d+$/.test(trimmedValue)) {
            errors.advance = "Advance must be numeric only";
        } else {
            const numericValue = parseInt(trimmedValue, 10);
            if (numericValue < 1 || numericValue > 99) {
                errors.advance = "Advance must be between 1 and 99";
            }
        }

        setError(errors);
        return Object.keys(errors).length === 0;
    };
    const updateAdvanceListData = async () => {
        if (!validateFields()) return;
        try {
            const payload = {
                amount: advance
            };
           // console.log(".........", payload)
            const response = await API.updateAdvanceData(id, payload);
            // console.log(".....rrr....", response?.data)
            if (response?.status === 200) {
                toast.success(response?.data?.message);
                getAdvanceList()
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update Card Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error updating discount :", error);
            toast.error("An unexpected error occurred. Please try again later.");
        }
    }


    const changeStatus = async (id, currentStatus) => {
        //console.log("stautus...",id, currentStatus)
        const updatedStatus = !currentStatus;
        try {
            const response = await API.changeAdvanceStatus(id, updatedStatus);
          //  console.log(".........", response?.data)
            if (response.status === 200) {
                setAdvanceList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Advance  ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
                getAdvanceList();
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            handleError(error);
        }
    };


    const handleError = (error) => {
        console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const handleCancel = () => {
        setId("")
        setAdvance("")
    }


    return (
        <div>
            <div >
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h4 className="card-title mb-0">Added Advance</h4>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered text-center">
                                    <thead>
                                        <tr>
                                            <th>SrNo</th>
                                            <th>Action</th>
                                            <th>Advance</th>
                                            <th>Status</th>
                                            <th>Created-Date</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {advanceList.map((item, index) => (
                                            <tr key={item.id} data-active={item?.is_active ? "true" : "false"}>
                                                <td>{(currentPage - 1) * perPage + index + 1}</td>
                                                <td>
                                                    <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                        <ul className="navbar-nav navbar-nav-right">
                                                            <li className="nav-item nav-profile1">
                                                                <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <div className="nav-profile-text1">
                                                                        <p className="mb-1 text-black">
                                                                        </p>
                                                                    </div>
                                                                </span>
                                                                <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                                <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                    <a className="dropdown-item">
                                                                        <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalViewDiscount">
                                                                            View
                                                                        </button>
                                                                    </a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a className="dropdown-item">
                                                                        <button onClick={() => handleGetData(item.id)}
                                                                            className="btn btn-primary btn-sm" type="button"
                                                                            data-bs-toggle="modal" data-bs-target="#myModal"
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                    </a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a className="dropdown-item">

                                                                        <button
                                                                            className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                            onClick={() => changeStatus(item.id, item.is_active)}
                                                                        >
                                                                            {item.is_active ? "De-Activate" : "Activate"}
                                                                        </button>

                                                                    </a>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td>{item.advance} %</td>
                                                <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                                <td>
                                                    {moment(item.createdAt).format("DD-MM-YYYY")}
                                                </td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                    <section>
                        <div className="modal" id="myModalViewDiscount">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Advance Details</h4>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                                    </div>
                                    <div className="modal-body">
                                        <table className="table table-bordered border-secondary">
                                            <thead>
                                                <tr>
                                                    <th>Advance</th>
                                                    <th>Status</th>
                                                    <th>Created Date</th>
                                                </tr>
                                                <tr>
                                                    <td>{advance} %</td>
                                                    <td>{status ? "Active" : "De-Activated"}</td>
                                                    <td>{moment(createdDate).format("DD-MM-YYYY")}</td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                    <div className="modal-footer">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section>
                        <div className="modal fade" id="myModal" data-bs-backdrop="static">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Update Advance Details</h4>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="advance">
                                                        Advance (%) <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="advance"
                                                        placeholder="Enter Advance"
                                                        value={advance}
                                                        onChange={handleFieldChange}
                                                    />
                                                    {error?.advance && (
                                                        <span className="text-danger" style={{ fontSize: "12px" }}>
                                                            {error.advance}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-end gap-2 mt-4">
                                            <button className="btn btn-primary" onClick={updateAdvanceListData}>Update</button>
                                            <button onClick={handleCancel} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <ToastContainer />
            </div>
        </div>

    );
};

export default AdvanceList;